import styled, { keyframes } from "styled-components";

export const ClickablePageThumbnail = styled.div`
  box-sizing: border-box;
  height: 157px;
  cursor: pointer;
  border: ${(props) =>
    props.selected ? "1px solid #ff6d1d" : "1px solid transparent"};
  display: inline-block;
  box-shadow: 0 2px 6px #0000000f;
`;

export const SplitContainer = styled.div`
  position: relative;
  height: 194px;
  width: 2px;
`;

const skeletonLoading = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export const SplitSkeletonContainer = styled.div`
  position: relative;
  height: 194px;
  width: 2px;
`;

export const LineSkeleton = styled.div`
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%);
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    animation: ${skeletonLoading} 1.2s ease-in-out infinite;
  }
`;

export const ToggleButtonSkeleton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      transparent,
      rgba(255, 255, 255, 0.9),
      transparent
    );
    animation: ${skeletonLoading} 1s ease-in-out infinite;
  }
`;

export const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

// Global shimmer animation for "AI is thinking" button
export const globalShimmer = keyframes`
  0% { 
    transform: translateX(-100%); 
  }
  100% { 
    transform: translateX(100%); 
  }
`;

export const fadeIn = keyframes`
  0% { 
    opacity: 0; 
    transform: translateY(10px); 
  }
  100% { 
    opacity: 1; 
    transform: translateY(0); 
  }
`;

export const ClickablePageThumbnailSkeleton = styled.div`
  height: 155px;
  width: 120px;
  background: linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
    animation: ${shimmer} 1.3s ease-in-out infinite;
  }
`;

export const Line = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) => (props.selected ? "#ff6d1d" : "#DCDCE1")};
`;

export const ToolbarButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const ToggleButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 12px;
  width: 12px;
  background-color: ${(props) => (props.selected ? "#ff6d1d" : "#DCDCE1")};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ConfidenceLabel = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  padding: 2px 6px;
  background-color: #ff6d1d;
  transform: translateX(-50%);
  color: white;
  font-weight: 600;
  font-size: 14px;
`;

export const IframeSkeleton = styled.div`
  width: 100%;
  height: 698px;
  background: linear-gradient(90deg, #f8f9fa 25%, #e9ecef 50%, #f8f9fa 75%);
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.7),
      transparent
    );
    animation: ${shimmer} 1.5s ease-in-out infinite;
  }
`;

export const SplitterFadeIn = styled.div`
  animation: ${fadeIn} 0.5s ease-out forwards;
  display: flex;
  flex-wrap: wrap;
  gap: 34px;
  align-items: flex-end;
`;

export const SplitterPageFadeIn = styled.div`
  animation: ${fadeIn} 0.5s ease-out forwards;
  display: flex;
  flex-direction: row;
  gap: 35px;
  align-items: flex-end;
`;

export const AIThinkingButton = styled.div`
  width: 100%;
  height: 48px;
  background-color: #fff3ec;
  color: #FF6D1D;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  margin: 48px;
  border: 1.5px solid #fff3ec;
  cursor: not-allowed;
  opacity: 0.5;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 109, 29, 0.3) 50%, transparent 100%);
    animation: ${globalShimmer} 1.5s infinite;
    z-index: 1;
  }

  span {
    position: relative;
    z-index: 2;
  }
`;
